export interface MarketSummary {
  ID: string;
  WeekNumber: number;
  Year: number;
  Title: string;
  Content: string; // HTML rich text
  Source: string;
  Disclaimer: string;
  PublishedAt: string;
  CreatedAt: string;
  UpdatedAt: string;
  CreatedBy: string;
}

export interface MarketEvent {
  ID: string;
  Title: string;
  Description: string;
  EventDate: string;
  EventType: MarketEventType | string; // supports custom types
  Color: string; // hex color for the event type chip
  CreatedAt: string;
  UpdatedAt: string;
  CreatedBy: string;
}

export type MarketEventType = 'auction' | 'regulatory' | 'economic' | 'custom';

export const MARKET_EVENT_TYPE_CONFIG: Record<string, { label: string; defaultColor: string }> = {
  auction: { label: 'EUA Auction', defaultColor: '#1976D2' },
  regulatory: { label: 'Regulatory Deadline', defaultColor: '#D32F2F' },
  economic: { label: 'Economic Event', defaultColor: '#388E3C' },
  custom: { label: 'Custom', defaultColor: '#7B1FA2' },
};
